/* eslint-disable no-console */

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    const basePath = process.env.BASE_URL || "/";
    const scopeUrl = new URL(basePath, window.location.origin).href;

    try {
      const registrations = await navigator.serviceWorker.getRegistrations();

      await Promise.all(
        registrations
          .filter((registration) => registration.scope.startsWith(scopeUrl))
          .map((registration) => registration.unregister())
      );

      if ("caches" in window) {
        const cacheNames = await window.caches.keys();

        await Promise.all(
          cacheNames.map(async (cacheName) => {
            const cache = await window.caches.open(cacheName);
            const requests = await cache.keys();
            const hasDashboardAsset = requests.some((request) =>
              request.url.startsWith(scopeUrl)
            );

            if (hasDashboardAsset) {
              await window.caches.delete(cacheName);
            }
          })
        );
      }
    } catch (error) {
      console.error("Error while clearing service worker cache:", error);
    }
  });
}
